import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
interface TechnologyPartner {
  name: string;
  url: string;
  logo: string;
}
const technologyPartners: TechnologyPartner[] = [{
  name: 'ServiceNow',
  url: 'https://www.servicenow.com/',
  logo: 'https://jobs.newriversystems.com/wp-content/uploads/2024/04/partner-logos-servicenow-400.png'
}, {
  name: 'Proven Optics',
  url: 'https://provenoptics.com/',
  logo: 'https://jobs.newriversystems.com/wp-content/uploads/2024/04/partner-logos-proven-optics-400.png'
}, {
  name: 'Infor',
  url: 'https://www.infor.com/',
  logo: 'https://jobs.newriversystems.com/wp-content/uploads/2024/04/partner-logos-infor-400.png'
}, {
  name: 'SAP',
  url: 'https://www.sap.com/',
  logo: 'https://jobs.newriversystems.com/wp-content/uploads/2024/04/partner-logos-SAP-400.png'
}, {
  name: 'Saviynt',
  url: 'https://saviynt.com/',
  logo: 'https://jobs.newriversystems.com/wp-content/uploads/2024/04/partner-logos-saviynt-400.png'
}, {
  name: 'IBM',
  url: 'https://www.ibm.com/',
  logo: 'https://jobs.newriversystems.com/wp-content/uploads/2024/04/partner-logos-IBM-400.png'
}, {
  name: 'SailPoint',
  url: 'https://www.sailpoint.com/',
  logo: 'https://jobs.newriversystems.com/wp-content/uploads/2024/04/partner-logos-sailpoint-400.png'
}, {
  name: 'CaseCracker',
  url: 'https://www.casecracker.com/',
  logo: 'https://jobs.newriversystems.com/wp-content/uploads/2024/04/partner-logos-case-cracker400.png'
}];
export function PartnersPage() {
  return <div className="w-full" data-id="element-1979" data-mp="47ez9ld2jp9c">
      {/* HERO SECTION */}
      <section className="section-navy hero-grid-pattern" data-id="element-1980" data-mp="46vk2ceszez0">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-1981" data-mp="21xonjlp5zx34">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} data-id="element-1982" data-mp="25yid0ji99jy4">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight max-w-4xl mx-auto" data-id="element-1983" data-mp="260ldxyky4xhm">
              Our Partners
            </h1>
            <div className="h-1.5 w-24 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-1984" data-mp="34be8q7puq4n5"></div>
            <p className="text-xl text-nrs-light font-bold max-w-2xl mx-auto" data-id="element-1985" data-mp="3ia42bddgpm6r">
              Collaborating with industry leaders to deliver excellence
            </p>
          </motion.div>
        </div>
      </section>

      {/* SERVICENOW PARTNERSHIP */}
      <section className="section-white" data-id="element-1986" data-mp="3s6pcse893phz">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-1987" data-mp="3n9ql02c27umy">
          <div className="max-w-4xl mx-auto card border-l-4 border-l-nrs-navy" data-id="element-1988" data-mp="3n7mfjfyiinkk">
            <h3 className="text-2xl font-bold mb-4" data-id="element-1989" data-mp="5s5vo9rw5w7t">
              ServiceNow Select Partner
            </h3>
            <p className="text-lg text-nrs-gray mb-6 leading-relaxed" data-id="element-1990" data-mp="vyyp6hh3v20">
              New River Systems is a Select Partner in the ServiceNow Partner
              Program, with deep
              platform expertise across ITSM, HRSD, SPM, Security Operations,
              and GRC. Our certified developers and architects collaborate with
              ServiceNow Impact teams to deliver complete governance and
              development solutions.
            </p>
            <ul className="space-y-3 text-nrs-gray" data-id="element-1991" data-mp="kew743zbx574">
              <li className="flex items-start gap-2" data-id="element-1992" data-mp="oh9gd2dabl8n">
                <span className="text-nrs-navy font-bold" data-id="element-1993" data-mp="ofojv77ets85">•</span> Certified
                ServiceNow developers and architects
              </li>
              <li className="flex items-start gap-2" data-id="element-1994" data-mp="fgb7o6rwipjq">
                <span className="text-nrs-navy font-bold" data-id="element-1995" data-mp="fi5whw6an1t3">•</span> Platform
                specialization: ITSM, HRSD, SPM, SecOps, GRC
              </li>
              <li className="flex items-start gap-2" data-id="element-1996" data-mp="5q8fg8sltfmg">
                <span className="text-nrs-navy font-bold" data-id="element-1997" data-mp="5r1iayofzkzb">•</span> Collaboration
                with ServiceNow Impact teams
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* TECHNOLOGY PARTNERS */}
      <section className="section-light-blue" data-id="element-1998" data-mp="3kuibe35d9rg1">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-1999" data-mp="3kua0ggst0w7h">
          <h2 className="text-3xl font-bold text-center mb-4" data-id="element-2000" data-mp="3fwq8ke36okx2">
            Technology Partners
          </h2>
          <div className="h-1 w-16 bg-nrs-orange mx-auto rounded-full mb-12" data-id="element-2001" data-mp="3b3np4ys4erul"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2002" data-mp="3746hbyp81im9">
            {technologyPartners.map(partner => <a key={partner.name} href={partner.url} target="_blank" rel="noopener noreferrer" className="card flex items-center justify-center min-h-[200px] p-8 transition-all hover:shadow-md hover:border-nrs-orange/40" data-id="element-2003" data-mp="32539y7lrr0b4">
                <img src={partner.logo} alt={`${partner.name} logo`} loading="lazy" className="max-h-28 w-full max-w-[260px] object-contain" data-id="element-2004" data-mp="2s8709yk4w84z" />
              </a>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-navy" data-id="element-2005" data-mp="md60nremuz53">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-2006" data-mp="me7do1f7lvpg">
          <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-2007" data-mp="24bkioo490ml9">
            Interested in Partnering with New River Systems?
          </h3>
          <p className="text-lg text-nrs-light mb-8" data-id="element-2008" data-mp="29815nezpouwr">
            We're always open to strategic partnerships that benefit our federal
            clients.
          </p>
          <Link to="/contact-us" className="btn-primary bg-white text-nrs-navy hover:bg-nrs-light" data-id="element-2009" data-mp="2i14e18vi2hkj">
            Contact Business Development
          </Link>
        </div>
      </section>
    </div>;
}